enum ButtonTheme {
  Purple = "purple",
}

export default ButtonTheme;
